import { Navigate, Outlet } from "react-router";
import { useAppSelector } from "../../store/hooks";

const PublicRoute = () => {
  const { user, token, initialized } = useAppSelector((state) => state.auth);

  if (token && initialized && user) {
    // If already logged in, redirect to respective dashboard
    return <Navigate to={user.role === 'listener' ? "/listener/dashboard" : "/dashboard"} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
